import React,{ Component } from 'react';
import { connect } from 'react-redux';
import { Col } from 'reactstrap';

class Content extends Component{
    render(){
        const { sideBarState } = this.props;
        const cols = sideBarState ? { offset: 2, size: 10, expand: "expand"}:{size: 12, expand: ""};
        return (
            <Col md={cols} xs="12" className={ `content ${cols.expand}` }>
                <div className="px-0">
                    { this.props.children }
                </div>
            </Col>
        );
    }
}

const mapStateToProps = (state) => ({
    sideBarState: state.layout.sidebar_toggle,
});
export default connect(mapStateToProps)(Content);


// WEBPACK FOOTER //
// ./src/Components/App/Layout/Content.js